import { compose, withProps, withState } from 'recompose'
import { connect } from 'react-redux'
import withRequestApptClick from 'components/common/hoc/withRequestApptClick'
import NeedHelp from './NeedHelp'
import { getCurrentStoreIsE2EAppointment } from 'selectors/getCurrentStore'
import { SCHEDULE_APPOINTMENT, REQUEST_APPOINTMENT } from 'constant'

const withIsHoveredState = withState('isHovering', 'setIsHovering', false)

const mapStateToProps = (state) => ({
  isE2EAppointment: getCurrentStoreIsE2EAppointment(state)
})

const withInfo = withProps(({ isE2EAppointment }) => ({
  appointmentTitle: isE2EAppointment ? SCHEDULE_APPOINTMENT.toUpperCase() : REQUEST_APPOINTMENT.toUpperCase()
}))

export default compose(
  connect(mapStateToProps),
  withIsHoveredState,
  withProps(() => ({ navigateToQuickApptPage: true })),
  withRequestApptClick,
  withInfo
)(NeedHelp)
